package com.exura.features.publicplans.domain.usecase

import com.exura.features.publicplans.domain.model.PublicPlanServingEntry
import com.exura.features.publicplans.domain.repository.ProviderPublicPlanRepository
import kotlinx.coroutines.flow.Flow

class GetPublicPlanServingsUseCase(
    private val repository: ProviderPublicPlanRepository,
) {
    suspend operator fun invoke(id: String): Result<Flow<List<PublicPlanServingEntry>>> = runCatching{
        repository.getPublicPlanServingHistory(id)
    }
}
